import { useMemo } from "react";
import { getAdminName } from "./cookieUtils";

export const DAYS_OF_WEEK = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const MONTHS_OF_YEAR = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const useDateAndAdmin = () => {
  const currentDate = useMemo(() => new Date(), []);
  const adminData = getAdminName();

  const dayOfWeekIndex = currentDate.getDay();
  const monthIndex = currentDate.getMonth();
  const dayOfMonth = currentDate.getDate();

  const formattedDate = `${DAYS_OF_WEEK[dayOfWeekIndex]}, ${MONTHS_OF_YEAR[monthIndex]} ${dayOfMonth}`;

  return {
    currentDate,
    adminData,
    formattedDate,
    daysOfWeek: DAYS_OF_WEEK,
    monthsOfYear: MONTHS_OF_YEAR,
  };
};

export const formatDate = (date) => {
  const dayOfWeekIndex = date.getDay();
  const monthIndex = date.getMonth();
  const dayOfMonth = date.getDate();

  return `${DAYS_OF_WEEK[dayOfWeekIndex]}, ${MONTHS_OF_YEAR[monthIndex]} ${dayOfMonth}`;
};
